const RouteConstants = {
    DASHBOARD: "/auth",
    COMPANIES: "/auth/companies",
    SCHOOLS: "/auth/schools",
    GROUPS: "/auth/roles",
    GROUP: "/auth/role",
    USERS: "/auth/users",
    STUDENTS: "/auth/students",
    INVOICES: "/auth/invoices",
    RECEIPTS: "/auth/receipts",
    VOUCHERS: "/auth/vouchers",
    JOURNALS: "/auth/journals",
    DEBIT_NOTES: "/auth/debit_notes",
    CREDIT_NOTES: "/auth/credit_notes",
    CSV_UPLOAD: "/auth/csv_upload",
    CHART_OF_ACCOUNTS: "/auth/chart_of_accounts",
    CONFIGURATIONS: "/auth/configurations",
    FORMS: "/auth/forms",
    DISCOUNTS: "/auth/discounts",
    REPORTS: "/auth/reports",
    DAILY_FEE_COLLECTION: "/auth/reports/daily_fee_collection",
    OUTSTANDING_FEES: "/auth/reports/outstanding_fees"
};

export default RouteConstants;